import { ModifyPromotion } from 'pages/AddPromotion/AddPromotion';
export default ModifyPromotion;
